export const preparePhone = (phone: string | undefined)=>(phone ?? '').replace(/\D/g, '').slice(0, 11)